import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "max-w-screen-md px-24"
};
const _hoisted_2 = { class: "px-24" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    class: "mx-auto h-24 w-24 text-slate-400 mb-3",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2",
    role: "img",
    focusable: "false",
    "aria-labelledby": "balance-code"
};
const _hoisted_5 = {
    id: "balance-code",
    class: "text-center uppercase font-semibold my-3 text-2xl"
};
const _hoisted_6 = { class: "text-portal-primary text-4xl" };
const _hoisted_7 = { class: "my-3" };
const _hoisted_8 = {
    key: 0,
    class: "text-center text-error-500 text-lg font-semibold"
};
const _hoisted_9 = {
    key: 1,
    class: "text-center text-error-500 text-xl font-semibold py-32"
};
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 2 };
const _hoisted_13 = {
    key: 2,
    class: "text-center text-sm"
};
const _hoisted_14 = {
    key: 2,
    class: "my-3"
};
const _hoisted_15 = {
    key: 0,
    class: "grid grid-cols-3 gap-6 px-4 -mx-24 mb-6"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = { class: "text-center text-sm" };
const _hoisted_19 = { key: 3 };
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = { class: "font-medium text-center" };
const _hoisted_22 = { class: "grid grid-cols-3 gap-4 my-6 font-medium" };
const _hoisted_23 = {
    key: 0,
    class: "flex"
};
const _hoisted_24 = {
    key: 1,
    class: "flex"
};
const _hoisted_25 = {
    key: 2,
    class: "flex"
};
const _hoisted_26 = { class: "grid grid-cols-3 gap-4 mb-6" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "portal-form mb-6" };
const _hoisted_29 = { class: "mb-6" };
const _hoisted_30 = {
    key: 0,
    class: "error-message"
};
const _hoisted_31 = { class: "form-group" };
const _hoisted_32 = { class: "mt-2" };
const _hoisted_33 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_34 = { class: "my-3" };
const _hoisted_35 = ["disabled", "aria-disabled"];
const _hoisted_36 = { class: "text-center text-sm" };
const _hoisted_37 = {
    key: 1,
    class: "max-w-screen-md"
};
const _hoisted_38 = { class: "px-24" };
const _hoisted_39 = ["src"];
const _hoisted_40 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    class: "text-slate-400 mx-auto h-24 w-24",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2",
    role: "img",
    focusable: "false",
    "aria-labelledby": "enter-code"
};
const _hoisted_41 = { class: "portal-form py-12" };
const _hoisted_42 = { class: "mb-6" };
const _hoisted_43 = {
    key: 0,
    class: "error-message"
};
const _hoisted_44 = { class: "form-group" };
const _hoisted_45 = { class: "mt-2" };
const _hoisted_46 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_47 = { class: "mt-2" };
const _hoisted_48 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_49 = { class: "mt-2" };
const _hoisted_50 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_51 = { class: "mt-2" };
const _hoisted_52 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_53 = { class: "mt-2" };
const _hoisted_54 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_55 = { class: "mt-2" };
const _hoisted_56 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_57 = { class: "flex items-center" };
const _hoisted_58 = {
    key: 0,
    class: "input-error-message text-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.form.redemption)
            ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.account.icon_two)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.app.cloudfront_asset_url + _ctx.account.icon_two,
                            alt: "Balance Code Icon",
                            class: "mx-auto max-h-24"
                        }, null, 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("title", null, "Enter Your Code Below", -1),
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                                }, null, -1)
                            ]))])),
                    _createElementVNode("h1", _hoisted_5, [
                        _cache[18] || (_cache[18] = _createTextVNode(" You have ", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.f.formatCurrency(_ctx.form.code().currency_code, _ctx.form.code().balance / 100)), 1),
                        _cache[19] || (_cache[19] = _createTextVNode(" remaining ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        (_ctx.form.campaignIsActive() && _ctx.form.campaign().status.seconds_remaining !== true)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Campaign Expires In " + _toDisplayString(_ctx.form.campaign().status.expires_in), 1))
                            : (!_ctx.form.campaignIsActive())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                    (_ctx.form.getCampaignStatus() === 'Expired')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Sorry but this campaign has expired. "))
                                        : (_ctx.form.getCampaignStatus() === 'Upcoming')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Sorry but this campaign has not started yet. "))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_12, "Sorry but this campaign is not available at this time."))
                                ]))
                                : _createCommentVNode("", true),
                        (!_ctx.form.campaignIsActive())
                            ? (_openBlock(), _createElementBlock("nav", _hoisted_13, [
                                _createElementVNode("a", {
                                    href: "#",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.form.resetRedemption()), ["prevent"]))
                                }, "Go Back")
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.form.campaignIsActive() && !_ctx.form.productSelected())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "font-semibold text-lg uppercase text-center mb-6" }, "Choose from the brands below", -1)),
                            (_ctx.form.productsLoaded())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.products, (product) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "flex items-center rounded justify-center hover:outline outline-offset-4 outline-portal-primary rounded-xl w-full py-0.5 cursor-pointer",
                                            onClick: _withModifiers(($event) => (_ctx.form.selectProduct(product.sku)), ["prevent"])
                                        }, [
                                            _createElementVNode("img", {
                                                src: product.image,
                                                alt: product.sku,
                                                class: "object-contain rounded-xl mx-auto h-36"
                                            }, null, 8, _hoisted_17)
                                        ], 8, _hoisted_16));
                                    }), 256))
                                ]))
                                : (_openBlock(), _createBlock(_component_Loading, {
                                    key: 1,
                                    message: false
                                })),
                            _createElementVNode("nav", _hoisted_18, [
                                _createElementVNode("a", {
                                    href: "#",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.form.resetRedemption()), ["prevent"]))
                                }, "Go Back")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.form.campaignIsActive() && _ctx.form.productSelected())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "font-semibold text-lg uppercase text-center mb-6" }, "Choose a value for your gift", -1)),
                            _createElementVNode("img", {
                                src: _ctx.form.order.product.image,
                                alt: _ctx.form.order.product.sku,
                                class: "object-contain rounded-xl mx-auto h-56 mb-6"
                            }, null, 8, _hoisted_20),
                            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.form.order.product.name), 1),
                            _createElementVNode("ul", _hoisted_22, [
                                (_ctx.form.order.product.in_store)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [...(_cache[21] || (_cache[21] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-6 w-6 mr-2",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                                })
                                            ], -1),
                                            _createTextVNode(" In Store ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                (_ctx.form.order.product.online)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_24, [...(_cache[22] || (_cache[22] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-6 w-6 mr-2",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                                })
                                            ], -1),
                                            _createTextVNode(" Online ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                (_ctx.form.order.product.telephone)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, [...(_cache[23] || (_cache[23] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-6 w-6 mr-2",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                                })
                                            ], -1),
                                            _createTextVNode(" Telephone ", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.order.prefilledValues, (value) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        type: "button",
                                        class: "hover:bg-portal-primary hover:text-white",
                                        onClick: _withModifiers(($event) => (_ctx.form.order.selectPrefillValue(value)), ["prevent"])
                                    }, _toDisplayString(_ctx.f.formatCurrency(_ctx.form.order.product.currency, value)), 9, _hoisted_27));
                                }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    (_ctx.form.order.noFieldErrors())
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.form.order.getErrorMessage()), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.order.fieldHasErrors('value') }])
                                    }, [
                                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                                            for: "code",
                                            class: "uppercase"
                                        }, [
                                            _createTextVNode("Value"),
                                            _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_32, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                name: "value",
                                                id: "value",
                                                required: "",
                                                "aria-required": "true",
                                                autocomplete: "off",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.order.data.value) = $event))
                                            }, null, 512), [
                                                [_vModelText, _ctx.form.order.data.value]
                                            ])
                                        ]),
                                        (_ctx.form.order.fieldHasErrors('value'))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.form.order.getFieldError('value')), 1))
                                            : _createCommentVNode("", true)
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "w-full bg-portal-primary text-portal-secondary hover:bg-portal-primary-lighter",
                                    disabled: !_ctx.form.valueInput(),
                                    "aria-disabled": !_ctx.form.valueInput(),
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.createOrder()), ["prevent"]))
                                }, "Continue", 8, _hoisted_35)
                            ]),
                            _createElementVNode("nav", _hoisted_36, [
                                _createElementVNode("a", {
                                    href: "#",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.form.resetProductSelection()), ["prevent"]))
                                }, "Go Back")
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]))
            : _createCommentVNode("", true),
        (!_ctx.form.redemption)
            ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                    (_ctx.account.icon_one)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.app.cloudfront_asset_url + _ctx.account.icon_one,
                            alt: "Enter Code Icon",
                            class: "mx-auto max-h-24"
                        }, null, 8, _hoisted_39))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_40, [...(_cache[26] || (_cache[26] = [
                                _createElementVNode("title", null, "Enter Your Code Below", -1),
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                                }, null, -1)
                            ]))])),
                    _cache[36] || (_cache[36] = _createElementVNode("h1", {
                        id: "enter-code",
                        class: "text-center uppercase font-semibold my-6 text-2xl"
                    }, "Enter Your Code Below", -1)),
                    _createElementVNode("form", {
                        action: "#",
                        method: "post",
                        enctype: "multipart/form-data",
                        onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event) => (_ctx.form.redeemCode()), ["prevent"]))
                    }, [
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                                (_ctx.form.noFieldErrors())
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.form.getErrorMessage()), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('code') }])
                                }, [
                                    _cache[27] || (_cache[27] = _createElementVNode("label", {
                                        for: "code",
                                        class: "uppercase"
                                    }, [
                                        _createTextVNode("Code"),
                                        _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_45, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "code",
                                            id: "code",
                                            required: "",
                                            "aria-required": "true",
                                            autocomplete: "off",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.data.code) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.form.data.code]
                                        ])
                                    ]),
                                    (_ctx.form.fieldHasErrors('code'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.form.getFieldError('code')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                (_ctx.isGiftsVouchers())
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('key') }])
                                    }, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", {
                                            for: "key",
                                            class: "uppercase"
                                        }, [
                                            _createTextVNode("Authentication Key"),
                                            _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_47, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                name: "key",
                                                id: "key",
                                                required: "",
                                                "aria-required": "true",
                                                autocomplete: "off",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.data.key) = $event))
                                            }, null, 512), [
                                                [_vModelText, _ctx.form.data.key]
                                            ])
                                        ]),
                                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-500 pt-1" }, "If you do not know this please contact the organisation who supplied your Chooza code.", -1)),
                                        (_ctx.form.fieldHasErrors('key'))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.form.getFieldError('key')), 1))
                                            : _createCommentVNode("", true)
                                    ], 2))
                                    : _createCommentVNode("", true),
                                (_ctx.account.pin_verification)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('pin') }])
                                    }, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", {
                                            for: "pin",
                                            class: "uppercase"
                                        }, "PIN", -1)),
                                        _createElementVNode("div", _hoisted_49, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                name: "pin",
                                                id: "pin",
                                                required: "",
                                                "aria-required": "true",
                                                autocomplete: "off",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.data.pin) = $event))
                                            }, null, 512), [
                                                [_vModelText, _ctx.form.data.pin]
                                            ])
                                        ]),
                                        (_ctx.form.fieldHasErrors('pin'))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.form.getFieldError('pin')), 1))
                                            : _createCommentVNode("", true)
                                    ], 2))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('name') }])
                                }, [
                                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                                        for: "name",
                                        class: "uppercase"
                                    }, [
                                        _createTextVNode("Your Name"),
                                        _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_51, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "name",
                                            id: "name",
                                            required: "",
                                            "aria-required": "true",
                                            autocomplete: "name",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.form.data.name) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.form.data.name]
                                        ])
                                    ]),
                                    (_ctx.form.fieldHasErrors('name'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.form.getFieldError('name')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('email') }])
                                }, [
                                    _cache[32] || (_cache[32] = _createElementVNode("label", {
                                        for: "email",
                                        class: "uppercase"
                                    }, [
                                        _createTextVNode("Your Email"),
                                        _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_53, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            name: "email",
                                            id: "email",
                                            required: "",
                                            "aria-required": "true",
                                            autocomplete: "off",
                                            onCopy: _cache[9] || (_cache[9] = _withModifiers(() => { }, ["prevent"])),
                                            onPaste: _cache[10] || (_cache[10] = _withModifiers(() => { }, ["prevent"])),
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.data.email) = $event))
                                        }, null, 544), [
                                            [_vModelText, _ctx.form.data.email]
                                        ])
                                    ]),
                                    (_ctx.form.fieldHasErrors('email'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.form.getFieldError('email')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.form.fieldHasErrors('confirmEmail') }])
                                }, [
                                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                                        for: "confirmEmail",
                                        class: "uppercase"
                                    }, [
                                        _createTextVNode("Confirm Email"),
                                        _createElementVNode("span", { class: "req-asterisk text-portal-primary" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_55, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            name: "confirmEmail",
                                            id: "confirmEmail",
                                            required: "",
                                            "aria-required": "true",
                                            autocomplete: "new-password",
                                            onCopy: _cache[12] || (_cache[12] = _withModifiers(() => { }, ["prevent"])),
                                            onPaste: _cache[13] || (_cache[13] = _withModifiers(() => { }, ["prevent"])),
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.form.data.confirmEmail) = $event))
                                        }, null, 544), [
                                            [_vModelText, _ctx.form.data.confirmEmail]
                                        ])
                                    ]),
                                    (_ctx.form.fieldHasErrors('confirmEmail'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.form.getFieldError('confirmEmail')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('accepted') }])
                                }, [
                                    _createElementVNode("div", _hoisted_57, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "accepted",
                                            name: "accepted",
                                            type: "checkbox",
                                            required: "",
                                            "aria-required": "true",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.form.data.accepted) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.form.data.accepted]
                                        ]),
                                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                                            for: "accepted",
                                            class: "ml-2 block text-sm text-slate-900"
                                        }, [
                                            _createTextVNode(" Agree to our "),
                                            _createElementVNode("a", { href: "#" }, "Terms and conditions")
                                        ], -1))
                                    ]),
                                    (_ctx.form.fieldHasErrors('accepted'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(_ctx.form.getFieldError('accepted')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-span-6" }, [
                                    _createElementVNode("div", { class: "mt-2" }, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "w-full bg-portal-primary text-portal-secondary hover:bg-portal-primary-lighter"
                                        }, "Redeem Now")
                                    ])
                                ], -1))
                            ])
                        ])
                    ], 32)
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
